<template>
  <div>
    <b-card header="Relatórios">
      <b-card-group columns class="mt-3">
        <div v-for="(card, index) in cards" :key="index" class="mb-3 pb-3">
          <b-card v-if="hasPermission(card.permission)" footer-bg-variant="white" header-bg-variant="secondary"  border-variant="primary"
            class="text-center card-relatorios" :header="card.header" header-tag="header">
            <i :class="card.icon + ' fa-4x'"></i>
            <b-card-text class="mt-3 text">{{ card.text }}</b-card-text>
            <template #footer>
              <b-button size="sm" class="buttoncard" variant="primary" @click="setAction(card.action)">
                Gerar
              </b-button>
            </template>
          </b-card>
        </div>
      </b-card-group>
    </b-card>

    <v-relatorio-item-varejo :state="modalVendaVarejo" @update-modal="updateModalVenda"></v-relatorio-item-varejo>

    <v-relatorio-varejo :state="modalVarejo" @update-modal="update"></v-relatorio-varejo>

    <!-- Modal relatorio de atualização -->
    <b-modal title="Relatório de Atualização" size="xl" v-model="modalAtualizacao">
      <b-card>
        <b-row>
          <b-form-group label="Tipo do Relatório" v-slot="{ ariaDescribedby }">
            <b-form-radio v-model="atualizacao.tipo" :aria-describedby="ariaDescribedby" name="some-radios"
              value="pendente">Cadastros Com Atualização Pendente</b-form-radio>
            <b-form-radio v-model="atualizacao.tipo" :aria-describedby="ariaDescribedby" name="some-radios"
              value="atualizado">Cadastros Atualizados</b-form-radio>
          </b-form-group>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-form-group label="Data De: " label-for="data-de" description="Data de atualização do cadastro.">
              <b-form-input id="data-de" v-model="atualizacao.data_de" type="date" placeholder="Data de"
                required></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Data Ate: " label-for="data-de" description="Data de atualização do cadastro.">
              <b-form-input id="data-de" v-model="atualizacao.data_ate" type="date" placeholder="Data ate"
                required></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <span class="ml-3" style="font-size: 14px; color: #A9A9A9">Caso a data não seja informada, será gerado
            relatório
            dos últimos 90 dias!</span>
        </b-row>
      </b-card>
      <template #modal-footer>
        <downloadexcel size="sm" :disabled="loadAtt" :name="showFilename" worksheet="Atualizacao de Cadastros"
          class="btn btn-success mt-1" title="Atualizacao de Cadastros" :fetch="() => {
            return geraRelatorioAtt();
          }
            ">
          <b-spinner v-if="loadAtt" small label="Spinning"></b-spinner>
          <i v-if="!loadAtt" class="fas fa-chart-bar"></i>
          Gerar
        </downloadexcel>
        <b-button :disabled="loadAtt" variant="danger" @click="modalAtualizacao = false">Fechar</b-button>
      </template>
    </b-modal>
    <b-modal v-model="modalProspecto" title="Relatório de Prospectos" size="xl">
      <b-card>
        <b-form-group label="Data de: " label-for="data-de" description="Data de aprovação ou inativação do cadastro.">
          <b-form-input id="data-de" v-model="params.data_de" type="date" placeholder="Data de" required></b-form-input>
        </b-form-group>

        <b-form-group label="Data até: " label-for="data-ate"
          description="Data de aprovação ou inativação do cadastro.">
          <b-form-input id="data-ate" v-model="params.data_ate" type="date" placeholder="Data até"
            required></b-form-input>
        </b-form-group>
        <b-form-group label="Tipo: " label-for="tipo" description="Tipo de relatório, Sintético / Analítico / Inativo">
          <b-form-select v-model="params.tipo" :options="options"></b-form-select>
        </b-form-group>
      </b-card>
      <template #modal-footer>
        <downloadexcel :name="showFilename" worksheet="Acompanhamento Prospectos" class="btn btn-success mt-1"
          title="Acompanhamento de cadastros" :fetch="() => {
            return geraRelatorio();
          }
            " :before-generate="exportExcel" :before-finish="finishExcel">
          Gerar
        </downloadexcel>
        <b-button variant="danger" @click="showModal"> Fechar </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import downloadexcel from "vue-json-excel";
export default {
  props: {
  },
  name: "relatorio-prospectos",
  components: {
    downloadexcel,
  },

  data() {
    return {
      cards: [
        {
          header: "Relatório de Prospectos",
          icon: "fas fa-address-book",
          text: "Relatórios sintéticos, analíticos e cadastros inativados ",
          action: "showModal",
          permission: "list_relatorio_prospecto"
        },
        {
          header: "Relatório de Atualização",
          icon: "fas fa-user-check",
          text: "Relatórios de cadastros atualizados",
          action: "modalAtualizacao",
          permission: "list_relatorio_atualizacao"
        },
        {
          header: "Relatório de Produtos",
          icon: "fas fa-magic",
          text: "Relatório de produtos ativos",
          action: "relatorioProdutos",
          permission: "list_relatorio_produto"
        },
        {
          header: "Relatório Comissão Varejo",
          icon: "fas fa-search-dollar",
          text: "Relatório de comissão cadastros do varejo",
          action: "modalVarejo",
          permission: "list_relatorio_varejo"
        },
        {
          header: "Relatório Vendas Varejo",
          icon: "fas fa-boxes",
          text: "Relatório de vendas por item varejo",
          action: "modalVendaVarejo",
          permission: "list_relatorio_venda_varejo"
        },
      ],
      permissions: [],
      params: {
        data_de: "",
        data_ate: "",
        tipo: "SINTETICO",
      },
      atualizacao: {
        data_de: "",
        data_ate: "",
        tipo: "pendente",
      },
      modalVarejo: false,
      modalAtualizacao: false,
      modalVendaVarejo: false,
      loadAtt: false,
      relatorio: [],
      modalProspecto: false,
      options: ["SINTETICO", "ANALITICO", "INATIVO"],
    };
  },
  computed: {
    showFilename() {
      return new Date().getTime() + ".xls";
    },
  },
  mounted() {
    if (document.getElementById('permissions').value) {
      this.permissions = JSON.parse(document.getElementById('permissions').value)
    }
  },
  methods: {
    setAction(action) {
      if (action == 'showModal') {
        this.showModal();
      } else if (action == 'modalAtualizacao') {
        this.modalAtualizacao = true;
      } else if (action == 'relatorioProdutos') {
        this.relatorioProdutos();
      } else if (action == 'modalVarejo') {
        this.modalVarejo = true;
      } else if (action == 'modalVendaVarejo') {
        this.modalVendaVarejo = true;
      }
    },
    updateModalVenda(newStatus){
      this.modalVendaVarejo = newStatus;
    },
    update(newStatus) {
      this.modalVarejo = newStatus;
    },
    hasPermission(value) {
      return this.permissions.some(el => el.name == value)
    },
    relatorioProdutos() {
      window.open("/relatorios/produtos", "_blank");
    },
    async geraRelatorioAtt() {
      const vm = this;
      vm.loadAtt = true;
      const { data } = await axios.get("/relatorios/atualizacao", { params: vm.atualizacao })
        .then((response) => {
          if (response.data.length < 1) {
            vm.$swal(
              "Atenção",
              "Nenhum cadastro encontrado!",
              "warning"
            );
          }
          return response;
        }).catch((erro) => {
          console.log(erro);
          return erro
        }).finally(() => {
          vm.loadAtt = false
        })
      return data;
    },
    async geraRelatorio() {
      const vm = this;
      if (this.params.data_de === "") {
        $(".loading").hide();
        this.$swal("Informe a data de início da consulta", "", "error");
        return [];
      }
      if (this.params.data_ate === "") {
        $(".loading").hide();
        this.$swal("Informe a data fim da consulta", "", "error");
        return [];
      }

      const { data } = await axios
        .get("/relatorios/prospectos", { params: vm.params })
        .then(function (response) {
          if (response) {
            if (response.data.length < 1) {
              vm.$swal(
                "OPs",
                "Nenhum cadastro aprovado neste período!",
                "error"
              );
            }
            $(".loading").hide();
            return response;
          }

        })
        .catch(function (erro) {
          $(".loading").hide();
          console.log(erro);
          return erro;
        });
      return data;
    },
    exportExcel() {
      $(".loading").show();
    },
    finishExcel() {
      $(".loading").hide();
    },
    showModal() {
      this.modalProspecto = !this.modalProspecto;
      if (!this.modalProspecto) {
        this.params = {
          data_de: "",
          data_ate: "",
          tipo: "SINTETICO",
        };
        this.relatorio = [];
      }
    },
  },
};
</script>

<style>
.buttoncard {
  width: 100%;

  padding: 14px 20px;
  margin: 8px 0;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.card-relatorios {
  height: 300px;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/relatorios/prospectos.vue